import Storage from './Storage';

/**
 * Store TemplateList
 * 
 */
class TemplateList extends Storage {
    storeName = 'client_template_';
    hasOldKey = true;

    /**
     * TemplateList constructor
     * 
     * @param {string} id client id
     */
     constructor(id, theme_id) {
        super();
       // this.id = id + '_' + theme_id;
        this.id = id + '_flexy';
        //this.theme_id = theme_id;
        this.setKey();
    }

}

export default TemplateList;